
// --- Vue & Template imports ---
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

// --- Models ---
import { JobCard } from '@/models/JobCard.model';
import { Vehicle, WorkshopSummary } from '@/models/Vehicle.model';

// --- Third Party ---
import dayjs from 'dayjs';

@Component
export default class WheelIndicator extends Vue {
  @Prop() readonly item!: Vehicle | WorkshopSummary;
  @Prop() readonly disposalDate: string | undefined;
  @Prop({default: false}) readonly checkJobCards: boolean | undefined;
  @Prop({default: true}) readonly showJobCardStartDate: boolean | undefined;

  hasWarning: boolean = false;
  tooltip: string = '';
  displayStyle: string = '';
  openJobCard: JobCard = {
    id: 0,
    vehicle1Id: 0,
    vehicle1Code: '',
    vehicle1TypeId: 0,
    vehicle1Type: '',
    startDate: '',
    jobTypeId: 0,
    jobType: '',  
    originalEta: '',
    lineItemCount: 0,
    createdById: 0,
    createdBy: '',
  };

  @Watch('item', {
    immediate: true,
    deep: true,
  })
  checkWarning() {
    this.hasWarning = false;
    this.tooltip = '';
    this.displayStyle = '';

    if (this.item && this.item.id > 0) {
      if (!this.disposalDate) {
        if (this.item.odometer > this.item.nextWheelAlignmentOdo) {
          this.hasWarning = true;
          this.tooltip = 'Wheel Alignment Overdue';
          this.displayStyle = 'overdue';
        } else if (this.item.odometer + 5000 > this.item.nextWheelAlignmentOdo) {
          this.hasWarning = true;
          this.tooltip = 'Wheel Alignment Due';
          this.displayStyle = 'service-due';
        }

        if (this.checkJobCards) {
          // check if there is an open job card for this vehicle
          this.openJobCard = this.$store.getters['jobCards/openJobCards'].find((item: JobCard) => {
            if (item.vehicle1Id === this.item.id && item.jobType === 'Wheel Alignment') {
              return true;
            }

            if (item.vehicle2Id && item.vehicle2Id === this.item.id && item.jobType === 'Wheel Alignment') {
              return true;
            }
          });

          if (this.openJobCard) {
            this.hasWarning = true;
            this.tooltip = 'Job Card Open';
            this.displayStyle = 'primary--text';
          }
        }
      }

      this.displayStyle = this.item.suspended ? 'suspended' : this.displayStyle;
    }
  }

  getJobDate(startDate: string) {
    return dayjs(startDate).format('DD/MM').toUpperCase();
  }
}
